<template>
  <div class="session">
    <div>Session id: {{ session._id }}</div>
    <div>Start time: {{ startTime }}</div>
    <div class="usersInSessionTitle">Users in session</div>
    <div class="usersInSession">
      <div class="userInSession" v-for="user in session.users" :key="user.metadata.ID">
        <div>
          Display name:
          <button @click="selectUser(user.metadata.ID)">
            {{ user.metadata.displayName }}
          </button>
        </div>
        <div>userID: {{ user.metadata.ID }}</div>
        <div>Rematch status: {{ user.session.rematch }}</div>
        <button
          v-if="allowedUserViewing"
          @click="toggleRematchValue(user.metadata.ID, session._id, user.session.rematch)"
        >
          {{ user.session.rematch ? "Set rematch to false" : "Set rematch to true" }}
        </button>
        <div class="join-statuses">
          <div v-if="!getUserStamps(user.metadata.ID)">
            User has not joined session
          </div>
          <div v-else>
            <div v-for="(stamp, index) in getUserStamps(user.metadata.ID)" :key="index">
              <div v-if="stamp.type == 'join'" class="user-stamp">
                User <span class="joined stamp--base">joined</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'enter'" class="user-stamp">
                User <span class="enter stamp--base">entered</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'disconnected'" class="user-stamp">
                User <span class="disconnect stamp--base">disconnected</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_on'" class="user-stamp">
                User <span class="micOn stamp--base">mic on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_off'" class="user-stamp">
                User <span class="micOff stamp--base">mic off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_on'" class="user-stamp">
                User <span class="camOn stamp--base">cam on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_off'" class="user-stamp">
                User <span class="camOff stamp--base">cam off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'leave'" class="user-stamp">
                User <span class="leave stamp--base">leave</span>{{ ` at ${stamp.time}` }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
export default {
  name: "Session",
  props: {
    session: Object,
    allowedUserViewing: Boolean,
  },
  computed: {
    startTime() {
      return format(new Date(this.session.dateTime), `MMMM d, y, HH:mm`);
    },
  },
  methods: {
    selectUser(id) {
      this.$emit("selectUser", id);
    },
    toggleRematchValue(userID, sessionID, currentValue) {
      const newValue = !currentValue;
      this.$emit("toggleRematchValue", { userID, sessionID, newValue });
    },
    getUserStamps(userID) {
      let userStamps = [];
      if (this.session && this.session.timestamps && this.session.timestamps.length) {
        for (var i = 0; i < this.session.timestamps.length; i++) {
          let stamp = this.session.timestamps[i];
          let UID = stamp.UID;
          UID = UID.toString();
          if (UID == userID) {
            let stampObject = {
              UID: UID,
              type: stamp.type,
              time: format(new Date(stamp.stamp), `MMMM d, y, HH:mm`),
            };
            userStamps.push(stampObject);
          }
        }
      }
      if (userStamps && userStamps.length) {
        return userStamps;
      }

      return null;
    },
  },
};
</script>

<style scoped>
.user-stamp {
  border: 1px solid;
  margin: 5px 0px;
  padding: 8px 2px;
  font-size: 14px;
  text-align: center;
  background-color: azure;
}
.joined {
  background-color: #0000b9;
}
.leave {
  background-color: #9700b3;
}
.enter {
  background-color: #12ae12;
}
.disconnect {
  background-color: #b40000;
}
.stamp--base {
  padding: 0px 4px;
  color: white;
}
.micOn,
.camOn {
  background-color: #008fb4;
}
.micOff,
.camOff {
  background-color: #2a0007;
}
</style>
